import Invoice from './Invoice.container';

export default Invoice;
